// /frontend/src/pages/blog/BlogHome.js  (v2.0 – modernized UI)
// All logic identical to v1.
import '../../custom.css'

import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { blogPosts } from '../../data/blogPosts'

export default function BlogHome () {
  const [hovered, setHovered] = useState(null)

  // Group: featured = first post, rest = remainder
  const [featured, ...rest] = blogPosts

  return (
    <div style={{ fontFamily:"'DM Sans', system-ui, sans-serif", color:'#111827' }}>

      {/* ═══════════════════════════════════════
          HERO
      ═══════════════════════════════════════ */}
      <section style={{
        background : 'linear-gradient(160deg, #0f172a 0%, #1e3a5f 60%, #1d4ed8 100%)',
        padding    : '72px 24px 80px',
        textAlign  : 'center',
        position   : 'relative',
        overflow   : 'hidden',
      }}>
        <div style={{ position:'absolute', top:-100, right:-100, width:360, height:360, borderRadius:'50%', background:'rgba(37,99,235,0.2)', filter:'blur(60px)', pointerEvents:'none' }} />
        <div style={{ position:'relative', zIndex:1, maxWidth:620, margin:'0 auto' }}>
          <div style={{ display:'inline-flex', alignItems:'center', gap:6, background:'rgba(255,255,255,0.1)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:99, padding:'5px 16px', marginBottom:18 }}>
            <i className='fas fa-pen-nib' style={{ fontSize:11, color:'#60a5fa' }} />
            <span style={{ fontSize:12, fontWeight:700, color:'rgba(255,255,255,0.8)', textTransform:'uppercase', letterSpacing:'0.07em' }}>Tips, guides & updates</span>
          </div>
          <h1 style={{ fontSize:'clamp(2rem, 5vw, 3rem)', fontWeight:900, color:'#ffffff', marginBottom:14 }}>
            Greatly Social Blog
          </h1>
          <p style={{ fontSize:17, color:'rgba(255,255,255,0.7)', lineHeight:1.6 }}>
            Actionable tips, platform updates, and growth strategies for busy businesses and creators.
          </p>
        </div>
      </section>

      {/* ═══════════════════════════════════════
          FEATURED POST
      ═══════════════════════════════════════ */}
      {featured && (
        <section style={{ background:'#ffffff', padding:'56px 24px 40px' }}>
          <div style={{ maxWidth:1100, margin:'0 auto' }}>
            <div style={{ fontSize:11, fontWeight:800, textTransform:'uppercase', letterSpacing:'0.09em', color:'#9ca3af', marginBottom:20 }}>
              Featured Post
            </div>
            <Link
              to={`/blog/${featured.slug}`}
              style={{ textDecoration:'none' }}
              onMouseEnter={() => setHovered('featured')}
              onMouseLeave={() => setHovered(null)}
            >
              <div style={{
                display     : 'flex',
                flexWrap    : 'wrap',
                gap         : 32,
                background  : '#f8fafc',
                border      : `1.5px solid ${hovered === 'featured' ? '#2563eb' : '#e5e7eb'}`,
                borderRadius: 18,
                overflow    : 'hidden',
                transition  : 'all 0.2s',
                boxShadow   : hovered === 'featured' ? '0 8px 32px rgba(37,99,235,0.12)' : '0 1px 4px rgba(0,0,0,0.05)',
              }}>
                {/* Image */}
                <div style={{ flex:'1 1 340px', minHeight:260, overflow:'hidden' }}>
                  <img
                    src={featured.hero}
                    alt={featured.title}
                    style={{ width:'100%', height:'100%', objectFit:'cover', display:'block', transition:'transform 0.3s', transform: hovered === 'featured' ? 'scale(1.03)' : 'scale(1)' }}
                  />
                </div>
                {/* Content */}
                <div style={{ flex:'1 1 300px', padding:'32px 28px', display:'flex', flexDirection:'column', justifyContent:'center' }}>
                  <div style={{ fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.08em', color:'#2563eb', marginBottom:10 }}>
                    {featured.category || 'Social Media'}
                  </div>
                  <h2 style={{ fontSize:'clamp(1.2rem, 3vw, 1.7rem)', fontWeight:900, color:'#111827', lineHeight:1.25, marginBottom:12 }}>
                    {featured.title}
                  </h2>
                  <p style={{ fontSize:14, color:'#6b7280', lineHeight:1.7, marginBottom:20 }}>
                    {featured.excerpt}
                  </p>
                  <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                    <div style={{ width:32, height:32, borderRadius:'50%', background:'#eff6ff', display:'flex', alignItems:'center', justifyContent:'center' }}>
                      <i className='fas fa-user' style={{ fontSize:12, color:'#2563eb' }} />
                    </div>
                    <div>
                      <div style={{ fontSize:13, fontWeight:600, color:'#374151' }}>{featured.author || 'Greatly Social'}</div>
                      <div style={{ fontSize:12, color:'#9ca3af' }}>{new Date(featured.date).toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' })}</div>
                    </div>
                    <div style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:5, fontSize:13, fontWeight:700, color:'#2563eb' }}>
                      Read more <i className='fas fa-arrow-right' style={{ fontSize:11 }} />
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </section>
      )}

      {/* ═══════════════════════════════════════
          ALL POSTS GRID
      ═══════════════════════════════════════ */}
      <section style={{ background:'#f8fafc', padding:'48px 24px 80px' }}>
        <div style={{ maxWidth:1100, margin:'0 auto' }}>
          {rest.length > 0 && (
            <div style={{ fontSize:11, fontWeight:800, textTransform:'uppercase', letterSpacing:'0.09em', color:'#9ca3af', marginBottom:24 }}>
              Latest Posts
            </div>
          )}

          {blogPosts.length === 0 && (
            <div style={{ textAlign:'center', padding:'60px 0', color:'#9ca3af' }}>
              <i className='fas fa-pen-nib' style={{ fontSize:32, marginBottom:12, display:'block', opacity:0.4 }} />
              <div style={{ fontSize:15, fontWeight:600 }}>No posts yet — check back soon!</div>
            </div>
          )}

          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px, 1fr))', gap:20 }}>
            {(featured ? rest : blogPosts).map(post => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                style={{ textDecoration:'none' }}
                onMouseEnter={() => setHovered(post.slug)}
                onMouseLeave={() => setHovered(null)}
              >
                <div style={{
                  background  : '#ffffff',
                  border      : `1.5px solid ${hovered === post.slug ? '#2563eb' : '#e5e7eb'}`,
                  borderRadius: 14,
                  overflow    : 'hidden',
                  height      : '100%',
                  display     : 'flex',
                  flexDirection:'column',
                  transition  : 'all 0.18s',
                  boxShadow   : hovered === post.slug ? '0 6px 24px rgba(37,99,235,0.12)' : '0 1px 3px rgba(0,0,0,0.05)',
                }}>
                  {/* Thumbnail */}
                  <div style={{ height:190, overflow:'hidden' }}>
                    <img
                      src={post.hero}
                      alt={post.title}
                      style={{ width:'100%', height:'100%', objectFit:'cover', display:'block', transition:'transform 0.3s', transform: hovered === post.slug ? 'scale(1.05)' : 'scale(1)' }}
                    />
                  </div>

                  {/* Content */}
                  <div style={{ padding:'20px', flex:1, display:'flex', flexDirection:'column' }}>
                    {post.category && (
                      <div style={{ fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.08em', color:'#2563eb', marginBottom:8 }}>
                        {post.category}
                      </div>
                    )}
                    <h3 style={{ fontSize:15, fontWeight:800, color:'#111827', lineHeight:1.35, marginBottom:10, flex:1 }}>
                      {post.title}
                    </h3>
                    <p style={{ fontSize:13, color:'#6b7280', lineHeight:1.6, marginBottom:16 }}>
                      {post.excerpt}
                    </p>
                    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', paddingTop:12, borderTop:'1px solid #f3f4f6' }}>
                      <span style={{ fontSize:12, color:'#9ca3af' }}>
                        {new Date(post.date).toLocaleDateString('en-US', { month:'short', day:'numeric', year:'numeric' })}
                      </span>
                      <span style={{ fontSize:12, fontWeight:700, color:'#2563eb', display:'flex', alignItems:'center', gap:4 }}>
                        Read <i className='fas fa-arrow-right' style={{ fontSize:9 }} />
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════
          CTA STRIP
      ═══════════════════════════════════════ */}
      <section style={{ background:'linear-gradient(135deg, #1d4ed8, #2563eb)', padding:'56px 24px', textAlign:'center' }}>
        <div style={{ maxWidth:580, margin:'0 auto' }}>
          <h2 style={{ fontSize:'clamp(1.4rem, 3vw, 2rem)', fontWeight:900, color:'#ffffff', marginBottom:12 }}>
            Ready to put it all into practice?
          </h2>
          <p style={{ fontSize:16, color:'rgba(255,255,255,0.7)', marginBottom:28 }}>
            Try Greatly Social free for 14 days — no credit card needed.
          </p>
          <a
            href='/register'
            style={{
              display        : 'inline-flex',
              alignItems     : 'center',
              gap            : 8,
              padding        : '13px 32px',
              borderRadius   : 10,
              border         : 'none',
              background     : '#ffffff',
              color          : '#1d4ed8',
              fontSize       : 15,
              fontWeight     : 700,
              cursor         : 'pointer',
              textDecoration : 'none',
              boxShadow      : '0 4px 16px rgba(0,0,0,0.2)',
            }}
            onMouseEnter={e => e.currentTarget.style.background='#f0f9ff'}
            onMouseLeave={e => e.currentTarget.style.background='#ffffff'}
          >
            <i className='fas fa-arrow-right' style={{ fontSize:12 }} />
            Start Free Trial
          </a>
        </div>
      </section>
    </div>
  )
}